export default __webpack_public_path__ + "static/Quickinstallation_Tile_8815_Step_01-e39f4d700d0ddd3af3f0fd2d144c2551.webp";